import { useMemo } from "react";
import { checkPermission } from "@shared/utils";
import { useSelector } from "react-redux";
import { selectors } from "@shared/store";
import { isAppAdmin } from "@shared/utils/ACL";
import { Hospital } from "@shared/models";

function useCheckPermission(
  permission?: string,
  option?: { onlyAppAdmin?: boolean; hospital?: Hospital | null },
): boolean {
  const user = useSelector(selectors.getUserDetails());

  const onlyAppAdmin = useMemo(() => {
    return option?.onlyAppAdmin;
  }, [option]);

  const hospitalId = useMemo(() => {
    return option?.hospital?.id;
  }, [option]);

  const permitted = useMemo(() => {
    if (!user) return false;

    return permission ? checkPermission(permission, user, hospitalId) : true;
  }, [permission, user, hospitalId]);

  if (!user || (onlyAppAdmin && !isAppAdmin(user))) {
    return false;
  }

  if (isAppAdmin(user)) {
    return true;
  }

  return permitted;
}

export default useCheckPermission;
